<template>
  <r-panel :title="title" :button_add="true" @click_add="click_add">
    <r-item-table ref="table" :items.sync="values" :toolbar="false" :amount="amount" :title="title" :duplicate="duplicate"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RItemTable from "@/modules/redactor/views/item/r-item-table.vue";

export default {
  name: "r-item-panel",
  components: {RItemTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Items"),
    items: VueTypes.arrayOf(ItemKey),
    amount: VueTypes.bool.def(false),
    duplicate: VueTypes.bool.def(true),
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>